import { render } from "./TestLinks.vue?vue&type=template&id=1edfecc0"
import script from "./TestLinks.vue?vue&type=script&lang=js"
export * from "./TestLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__